// 储存不同角色的路由信息，用于动态路由和权限
const allColumn = {
  1: [
    {
      name: "首页",
      alias: "admin",
      icon: "el-icon-s-home",
      path: "admin",
    },
  ],
  // 市直监管部门和区市监管部门现合为一个路由信息
  3: [
    {
      name: "概况",
      alias: "survey",
      icon: "el-icon-menu",
      path: "survey",
    },
    {
      name: "举报投诉",
      alias: "matters",
      icon: "iconfont icon-jubao",
      path: "matters?type=0",
    },
    {
      name: "处理处罚",
      alias: "matters",
      icon: "iconfont icon-huanbaochufa",
      path: "matters?type=1",
    },
    {
      name: "监督检查结果",
      alias: "matters",
      icon: "iconfont icon-gongzuojiancha",
      path: "matters?type=2",
    },
    {
      name: "其他",
      alias: "matters",
      icon: "iconfont icon-qita",
      path: "matters?type=3",
    },
    {
      name: "代理机构申报信息",
      alias: "declaration",
      icon: "el-icon-s-claim",
      path: "declaration",
    },
    {
      name: "代理机构基本信息",
      alias: "agency-info",
      icon: "el-icon-s-order",
      path: "agency-info",
    },
    {
      name: "项目评分",
      alias: "score-situation",
      icon: "el-icon-star-off",
      path: "score-situation",
    },
    {
      name: "专家评分",
      alias: "expert-evaluate",
      icon: "el-icon-star-on",
      path: "expert-evaluate",
    },
  ],
  // 采购人
  5: [
    {
      name: "评价",
      alias: "p-project-list",
      icon: "el-icon-star-off",
      path: "p-project-list",
    },
  ],
  // 专家，移动端
  4: [
    {
      name: "项目列表",
      alias: "e-project-list",
      path: "e-project-list",
    },
    {
      name: "评价",
      alias: "e-scoring",
      path: "e-scoring",
    },
  ],
  // 代理机构
  6: [
    {
      name: "评价",
      alias: "a-project-list",
      icon: "el-icon-star-off",
      path: "a-project-list",
    },
    {
      name: "基本信息",
      alias: "a-base-info",
      icon: "el-icon-s-order",
      path: "a-base-info",
    },
  ],
};

export function getPermission(role) {
  return role == 2 ? allColumn[parseInt(role) + 1] : allColumn[role];
}

export const authRoutes = {
  1: ["admin"],
  // 市直监管部门和区市监管部门现合为一个路由信息
  3: [
    "survey",
    "matters",
    "declaration",
    "agency-info",
    "score-situation",
    "expert-evaluate",
  ],
  // 采购人
  5: ["p-project-list"],
  // 专家，移动端
  4: ["e-project-list", "e-scoring"],
  // 代理机构
  6: ["a-project-list", "a-base-info"],
};
